var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiff = function SvgDiff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.1111 4H10.4542C9.9633 4 9.56533 4.39797 9.56533 4.88889V9.56533H4.88889C4.39797 9.56533 4 9.9633 4 10.4542V19.1111C4 19.602 4.39797 20 4.88889 20H13.5458C14.0367 20 14.4347 19.602 14.4347 19.1111V14.4347H19.1111C19.602 14.4347 20 14.0367 20 13.5458V4.88889C20 4.39797 19.602 4 19.1111 4ZM9.56542 9.56531H12.8043C13.0125 9.56531 13.2187 9.60646 13.4109 9.68618C13.6031 9.76591 13.7778 9.88265 13.9248 10.0299C14.0718 10.1772 14.1885 10.3521 14.2679 10.5445C14.3473 10.7369 14.3878 10.9429 14.3875 11.151V14.3876H11.1503C10.7301 14.3876 10.327 14.2206 10.0298 13.9236C9.73263 13.6266 9.56565 13.2238 9.56542 12.8036V9.56531Z",
    clipRule: "evenodd"
  })));
};
export default SvgDiff;